module.exports = __webpack_public_path__ + "media/images/country_flags/de-cd6d4f523c1dfe8d7541efbce06a31e3.png";